import api from "./axios";

export const VerificationDetails = async () => {
  const response = await api.get("/users/verification/details/");
  return response.data.data;
};

export const PhysicalVerification = async (payload) => {
  const response = await api.post(
    "/users/verification/request-physical-verification/",
    payload,
  );
  return response.data.data;
};

export const IdVerification = async (payload) => {
  const response = await api.post(
    "/users/verification/request-id-verification/",
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const createVerifyPayment = async (payload) => {
  const response = await api.post(
    "/payments/create-physical-verification-payment/",
    payload,
  );

  return response.data.data;
};

export const paymentVerifyCallback = async (txnid) => {
  const response = await api.get(
    `/payments/payu/physical-verification/callback/`,
    {
      params: { txnid: typeof txnid === "object" ? txnid.txnid : txnid },
    },
  );
  return response.data?.data;
};

export const paymentVerifyStatus = async (payload) => {
  const response = await api.post(
    "/payments/payu/physical-verification-payment-status/",
    payload,
  );

  return response.data.data;
};

 export const verifyPincode = async (pincode) => {
  const res = await api.get("/users/verify/pincode/", {
    params: { pincode },
  });
  return res.data;
};

export const requestNewPincodeApi = async ({pincode}) => {
  return api.post("/users/pincode/request/", { pincode });
};



